import {Pressable, Text} from 'react-native';
import Animated, {
  interpolate,
  SharedValue,
  useAnimatedStyle,
} from 'react-native-reanimated';
import Styles from '../Styles';
import Localized from 'src/constants/AppStrings';
import {getDescriber} from 'src/components/elements/descriptor/DescriptorType';

const styles = getDescriber().getDeleteButtonStyleDescriptor();
const maxSwipeDistance = +styles.maxSwipeDistance.value;

const RenderRightDeleteActions = ({
  dragAnimatedValue,
  onPress,
}: {
  dragAnimatedValue: SharedValue<number>;
  onPress: () => void;
}) => {

  const animatedStyle = useAnimatedStyle(() => {
    const translateX = interpolate(
      dragAnimatedValue.value,
      [0, -maxSwipeDistance],
      [maxSwipeDistance + 1, 0],
    );
    return {transform: [{translateX}]};
  });

  return (
    <Animated.View style={[animatedStyle, styles.deleteWrapper]}>
      <Pressable
        style={styles.deleteView}
        onPress={onPress}
        nativeID={'Right Delete Action'}
      >
        <Text
          style={styles.deleteText}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
        >
          {Localized.Buttons.delete}
        </Text>
      </Pressable>
    </Animated.View>
  );
};

export {maxSwipeDistance};
export default RenderRightDeleteActions;
